import axios from '@/api/config';
const scheduleRule={
  getScheduleRule(data){
    return  axios.get(`${process.env.BASE_URL}/scheduleRule/getScheduleRule`, {params:data});
  },
}
export default scheduleRule



// WEBPACK FOOTER //
// ./src/api/scheduleRule.js